import {
    type CloverIpgConfig,
    CloverTerminalTransport,
} from './clover-backend-config.types';
import { CloverGatewayEnvironment } from './clover-gateway-environment.types';
import { CloverRpaModuleName } from './clover-rpa-module-names';
import { CloverIpgSystemId } from './clover-system-constants';

export const CloverIpgConfigProd: CloverIpgConfig = {
    ipg_id: CloverIpgSystemId,
    name: 'Clover',
    urlPattern: 'https://*.clover.com/*',
    workflow_prefix: 'clover',
    allowedWebsites: [
        {
            type: 'ipg',
            system_id: CloverIpgSystemId,
            url: 'https://www.clover.com',
            name: 'Clover Portal',
            allowedUrlPatterns: [
                'https://*.clover.com/*',
                'https://fdc-fedsso.firstdata.com/*',
            ],
            sessionPersistence: 'persistent',
            promoteSessionCookies: false,
            urlPatternsRules: [],
            fetchDefaultAction: 'allow',
            iframeUrlPatterns: [],
            iframeDefaultAction: 'allow',
        },
    ],
    rpaModules: [CloverRpaModuleName.CLOVER_IPG],
    environment: CloverGatewayEnvironment.PRODUCTION,
    terminal_transport: CloverTerminalTransport.CLOUD_PAY_DISPLAY,
};

export const CloverIpgConfigDemo: CloverIpgConfig = {
    ...CloverIpgConfigProd,
    allowedWebsites: CloverIpgConfigProd.allowedWebsites.map((website, index) =>
        index === 0
            ? {
                  ...website,
                  url: 'https://www.clover.com/global-developer-home/home',
                  name: 'Clover Portal (Sandbox)',
              }
            : website
    ),
    environment: CloverGatewayEnvironment.SANDBOX,
};
